import { Form, Input, Select } from 'antd'
import Button from '../../Atoms/Button/Button'
import FormTitle from '../../Atoms/FormTitle/FormTitle';
import InputFormContainer from '../../Atoms/InputFormContainer/InputFormContainer'
const { Option } = Select;

const CampainsInboundForm = ({ closeModalInbound, openModalInboundSecond, typeCampaing }) => {
  const [form] = Form.useForm();

  const sendForm = (e) => {
    console.log(e); // Aqui el objeto con los valores del formulario
    closeModalInbound()
    openModalInboundSecond()
  };

  return (
    <Form onFinish={sendForm} form={form} >
        <InputFormContainer label="Nombre:" indentificador="name">
          <Form.Item
            name="name"
            rules={[{ required: true, message: "Debes colocar el nombre de la campaña" }]}
          >
            <Input size="large" placeholder="Escoge un nombre atractivo para tu campaña… (max 70 caracteres)" />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer
          label="Objetivo:"
          indentificador="objectives"
        >
          <Form.Item name="objectives" rules={[{required: true, message: "Por favor ingresa los objetivos"}]}>
            <Select size="large" placeholder="Objetivos">
              <Option value="ventas">Ventas</Option>
            </Select>
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Acciones (basadas en las objetivos):" indentificador="actions">
          <Form.Item
            name="actions"
            rules={[{ required: true, message: "Por favor ingrese las Acciones" }]}
          >
            <Select placeholder="Acciones (basadas en las objetivos):" mode="multiple" size="large">
              <Select.Option value="Contratación" key={1}>Contratación</Select.Option>
              <Select.Option value="Renovación" key={2}>Renovación</Select.Option>
              <Select.Option value="Reserva" key={3}>Reserva</Select.Option>
            </Select>
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Tags o etiquetas asociadas a la campaña:" indentificador="tags">
          <Form.Item name="tags" rules={[{ required: true, message: "Por favor ingrese las Tags o etiquetas" }]}>
            <Select placeholder="Tags o etiquetas asociadas a la campaña:" mode="multiple" size="large">
              <Select.Option value="Contratación" key={1}>Etiqueta 1</Select.Option>
              <Select.Option value="Renovación" key={2}>Etiqueta 2</Select.Option>
              <Select.Option value="Reserva" key={3}>Etiqueta 3</Select.Option>
            </Select>
          </Form.Item>
        </InputFormContainer>

      {
        typeCampaing === 1 && 
        <>
        <FormTitle text="Indica el nivel de servicio: " />

        <InputFormContainer label="Selecciona una opción:" indentificador="nivel" >
          <Form.Item name="nivel" rules={[{required: true, message: "Por favor ingresa el nivel"}]}>
            <Select size="large" placeholder="Objetivos">
              <Option value="nivel_1">Nivel 1</Option>
            </Select>
          </Form.Item>
        </InputFormContainer>
        </>
      }

        <div className="buttons-container mt-30">
          <Button content="Continuar" type="primary" customClass="s-large m-auto" htmlType="submit" />
          <span className="button primary outline s-large m-auto">Ir al paso anterior</span>
        </div>
    </Form>
  )
}

export default CampainsInboundForm
